const PlayIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
    const {viewBox, fill, stroke, ...otherProps} = props
    return (
        <svg
            viewBox={viewBox ? viewBox : "0 0 87 96"}
            fill={fill ? fill : "currentColor"}
            stroke={stroke ? stroke : "currentColor"}
            {...otherProps}
        >
            <path d="M2,47.47c0-10.66,0-21.33,0-32C2.07,3.2,12.11-3.06,22.66,3Q51.27,19.26,79.53,36.18a13.61,13.61,0,0,1,0,23.54Q51.26,76.6,22.68,93C12.11,99,2.07,92.75,2,80.47,2,69.47,2,58.47,2,47.47Zm5.73.31c0,10.66,0,21.33,0,32,0,8.55,5.46,11.84,12.66,7.65Q47.58,71.6,74.68,55.65c8-4.7,7.93-10.77-.11-15.5q-27.1-16-54.3-31.74c-7-4.06-12.47-.83-12.53,7.37C7.67,26.44,7.72,37.11,7.72,47.78Z" />
        </svg>
    )
}

export default PlayIcon
